export function extractUniDataTableRows(input: unknown): any[] {
  const visited = new Set<unknown>()

  const walk = (node: unknown, depth = 0): any[] => {
    if (depth > 10) return []
    if (node == null) return []
    if (Array.isArray(node)) return node
    if (typeof node !== 'object') return []
    if (visited.has(node)) return []
    visited.add(node)

    const obj = node as Record<string, any>

    const rows = obj.rows
    if (Array.isArray(rows)) return rows
    if (rows && typeof rows === 'object' && typeof rows.length === 'number') {
      try {
        return Array.from(rows as ArrayLike<any>)
      } catch {
        // ignore
      }
    }

    if ('value' in obj) {
      const viaValue = walk(obj.value, depth + 1)
      if (viaValue.length > 0) return viaValue
    }

    if ('fields' in obj) {
      const viaFields = walk(obj.fields, depth + 1)
      if (viaFields.length > 0) return viaFields
    }

    return []
  }

  return walk(input)
}

